import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";

const useBorseRequestCompleteMutation = (closeModal) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { setCurrentRequest } = useContext(BorseContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ request }) =>
      callApi(
        `/scholarship/request/${request?.id}/submitRequest/${request?.surveySubmission?.submissionId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ),
    {
      onSuccess: () => {
        if (closeModal) {
          closeModal();
          setCurrentRequest();
        }
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
      },
    }
  );
};

export default useBorseRequestCompleteMutation;
